import { render, staticRenderFns } from "./PosHeader.vue?vue&type=template&id=507213e8&scoped=true&"
import script from "./PosHeader.vue?vue&type=script&lang=js&"
export * from "./PosHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507213e8",
  null
  
)

export default component.exports